var exports = {
  "kL": "xae11d333--e27ccb--container",
  "pB": "xae11d333--e27ccb--label-wrapper",
  "Rf": "xae11d333--e27ccb--heading-wrapper",
  "W4": "xae11d333--e27ccb--text-wrapper",
  "sQ": "xae11d333--e27ccb--bottom",
  "r5": "xae11d333--e27ccb--providers",
  "g4": "xae11d333--e27ccb--provider-icon",
  "F4": "xae11d333--e27ccb--arrow-button",
};

module.exports = exports;
